import { axiosInstance } from './api';
class CostAdjustmentApi{

    async getCostAdjustmentsByProductId(id){
        const url = `Product/${id}/CostAdjustment`;
        return axiosInstance().get(url).then(response => response.data);
    }
    
    async getCostAdjustment(productId, costAdjustmentId){
        const url = `Product/${productId}/CostAdjustment/${costAdjustmentId}`;
        return axiosInstance().get(url).then(response => response.data);
    }

    async updateCostAdjustment(productId, costAdjustment){
        const url = `Product/${productId}/CostAdjustment`;
        return axiosInstance().put(url, costAdjustment).then(response => response.data);
    }
    
    async createCostAdjustmentByProductId(costAdjustment){
        const url = `Product/${costAdjustment.productId}/CostAdjustment`;
        console.log(url, costAdjustment);
        return axiosInstance().post(url, costAdjustment).then(response => response.data);    
    }
}
export default CostAdjustmentApi;

